import { Injectable } from '@angular/core';
import { Manager } from '../../shared/models/admin/manager';
import { HttpClientService } from '../../core/http-client/http-client.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManageStaffService {

  private static readonly endpoint = 'Manager';
  constructor(private http: HttpClientService) { }

  /**
   * Manager details
   *
   *
   * @param id
   */
  get(id: number) {
    return this.http.get<Manager>(`${ManageStaffService.endpoint}/Details/${id}`);
  }

  /**
   * all managers
   * 
   * 
   * @returns 
   */
  list() {
    return this.http.get(`${ManageStaffService.endpoint}/GetAll`);
  }

  /**
   * Paginationed Managers list
   *
   *
   * @param body
   */
  listByPagination(body: any): Observable<Manager[]> {
    return this.http.post<Manager[]>(body, `${ManageStaffService.endpoint}/GetPaginationBy`);
  }
  changePassword(body: any): Observable<any> {
    return this.http.post<any>(body, `${ManageStaffService.endpoint}/ChangePassword`);
  }

  /**
   * Add new manager
   *
   *
   * @param model
   */
  create(model: Object): Observable<Manager> {
    return this.http.postFormData(model, `${ManageStaffService.endpoint}/Create/`);
  }

  registerStaff(model: Object): Observable<Manager> {
    return this.http.post(model, `${ManageStaffService.endpoint}/RegisterStaff`);
  }

  /**
   * Update current manager
   *
   *
   * @param managerId
   * @returns {Observable}
   */
  update(model: Object): Observable<Manager> {
    return this.http.postFormData<Manager>(model, `${ManageStaffService.endpoint}/Update`);
  }

  /**
   * Delete manager
   *
   *
   * @param managerId
   */
  delete(managerId: number) {
    return this.http.delete<boolean>(`${ManageStaffService.endpoint}/Delete/${managerId}`);
  }

  /**
   * to excel
   * 
   * 
   * @param body 
   * @returns 
   */
  exportToExcel(body: object) {
    return this.http.getForDownloadFile<Blob>(`${ManageStaffService.endpoint}/ExportToExcel`, { responseType: 'blob' }, body);
  }

  getPaginationByAccountStatus(body: any): Observable<Manager[]> {
    return this.http.post<Manager[]>(body, `${ManageStaffService.endpoint}/GetPaginationByAccountStatus`);
  }

  approveStaff(id: number): Observable<Manager> {
    return this.http.get<Manager>(`${ManageStaffService.endpoint}/ApproveStaff/${id}`);
  }

  getStaffInfoForPostRoom(id: string): Observable<any> {
    return this.http.get<Manager>(`${ManageStaffService.endpoint}/GetStaffInfoForPostRoom/${id}`);
  }
}
